import { IconButton } from "@material-ui/core"
import { useState } from "react"

import HelpIcon from '@material-ui/icons/Help';
import { FeedbackModal } from "../FeedbackModal";
export interface FeedBackInfoType {
    unit_key: string;
    key: string;
    img?: string;
    // empty means it doesn't matter
    attribute: string;
    // img:string;
}
export interface FeedbackMap {
    q_title: string;
    img?: string;
}
export const FeedBackInfoMap: FeedBackInfoType[] = [{
    unit_key: "parking",
    attribute: "accessible_wheelchair_symbol",
    key: "accessible_wheelchair_symbol",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/accessible_wheelchair_symbol.jpg`
}, {
    attribute: "stairs_steps_count__step_free",
    unit_key: "entrance",
    key: "stairs_steps_count",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/entrance_stairs_steps_count.jpeg`
}, {
    attribute: "",
    unit_key: "entrance",
    key: "door_width",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/entrance_door_width.jpg`
}, {
    attribute: "",
    unit_key: "entrance",
    key: "door_electric_opening_arc_markings",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/entrance_door_electric_opening_arc_markings.jpg`
}, {
    attribute: "",
    unit_key: "entrance",
    key: "door_electric_push_plate_markings",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/entrance_door_electric_push_plate_markings.png`
}, {
    attribute: "",
    unit_key: "reception_infodesk",
    key: "desk_contrast_markings",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/reception_infodesk_desk_contrast_markings.jpeg`
}, {
    attribute: "",
    unit_key: "reception_infodesk",
    key: "cane_holder",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/reception_infodesk_cane_holder.png`
}, {
    attribute: "stairs_steps_count__escalator",
    unit_key: "facility",
    key: "stairs_steps_count",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/facility_stairs_steps_count.jpeg`
}, {
    attribute: "",
    unit_key: "facility",
    key: "lift_buttons",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/facility_lift_buttons.jpeg`
}, {
    attribute: "",
    unit_key: "facility",
    key: "lift_mirrors",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/facility_lift_mirrors.jpg`
}, {
    attribute: "toilet_area_type__grab_rails_both_sides",
    unit_key: "toilet_room__private",
    key: "toilet_area_type",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/toilet_area_type_both_sides.jpeg`
}, {
    attribute: "toilet_area_type__grab_rails_one_side",
    unit_key: "toilet_room__private",
    key: "toilet_area_type",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/toilet_area_type_one_side.jpg`
}, {
    attribute: "",
    unit_key: "hospitality_room_type",
    key: "coat_rack_accessible_height",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/coat_rack_accessible_height.jpg`
}, {
    attribute: "",
    unit_key: "hospitality_room_type",
    key: "door_electric_push_plate_markings",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/hospitality_door_electric_push_plate_markings.png`

}, {
    attribute: "",
    unit_key: "hospitality_room_type",
    key: "desk_height_accessible",
    img: `${process.env.PUBLIC_URL}/static/img/feedback-images/desk_height_accessible.jpeg`
}]

export const ModalController = (p: {
    showButton: boolean
    feedbackMap?: FeedbackMap
}) => {
    const { showButton, feedbackMap } = p
    const [fnHandlers, setFnHandlers] = useState({
        openModal: () => { }
    })
    return <>
        <FeedbackModal feedbackMap={feedbackMap} onOpenModal={handler => setFnHandlers({
            ...fnHandlers, openModal: handler
        })} />
        {showButton && <IconButton onClick={fnHandlers.openModal} size="small" style={{ marginLeft: "5px", height: "min-content" }} >
            <HelpIcon />
        </IconButton>}
    </>
}